import gql from "graphql-tag";

export default gql`query VatToken($test:Boolean!) {
    vatToken(test:$test) 
  }`